export default "__VITE_ASSET__Ddv80g4t__"